/* PickListRenderer.js */

"use strict";
const PickListSelection = require("../pick_list/customSelect/PickListSelectionComponent");
const InputSearchControl = require("@gluenetworks/input_search_control");
const _ = require("lodash");
const rowHeightEstimate = 25;

class PickListRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("pick-list-gl");
        this._selectionContainer = document.createElement("div");
        this._selectionContainer.classList.add("selection-container", "pick-list-container");
        this._selectionLabel = document.createElement("label");
        this._selectionLabel.classList.add("list-label");

        // Move UI components
        this._moveContainer = document.createElement("div");
        this._moveContainer.classList.add("move-container");
        this._moveOptions = document.createElement("div");
        this._moveOptions.classList.add("pick-list-control");
        this._moveOptions.classList.add("select-single-option");
        this._moveSelected = document.createElement("div");
        this._moveSelected.classList.add("pick-list-control");
        this._moveSelected.classList.add("unselect-single-option");
        this._moveAllOptions = document.createElement("div");
        this._moveAllOptions.classList.add("pick-list-control");
        this._moveAllOptions.classList.add("select-all");
        this._moveAllSelected = document.createElement("div");
        this._moveAllSelected.classList.add("pick-list-control");
        this._moveAllSelected.classList.add("unselect-all");

        // Sort UI components
        this._sortContainer = document.createElement("div");
        this._sortContainer.classList.add("sort-container");
        this._sortContainer.setAttribute("disabled", "disabled");
        this._sortUp = document.createElement("div");
        this._sortUp.classList.add("pick-list-control");
        this._sortUp.classList.add("sort-control");
        this._sortDown = document.createElement("div");
        this._sortDown.classList.add("pick-list-control");
        this._sortDown.classList.add("sort-control");

        this._optionContainer = document.createElement("div");
        this._optionContainer.classList.add("option-container", "pick-list-container");
        this._optionsLabel = document.createElement("label");
        this._optionsLabel.classList.add("list-label");
        this._optionFilter = new InputSearchControl();
        this._optionFilter.renderer.rootElement.classList.add("option-element");

        this._optionList = new PickListSelection();
        this._optionList.renderer.rootElement.classList.add("value-list");
        this._selectList = new PickListSelection();
        this._selectList.renderer.rootElement.classList.add("value-list");

        this._rootElem.component = this._model;

        this._registerListeners();
        this.render();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */

    /********************************************/
    _registerListeners() {
        this._model.on("ShowFilter", (this._onShowFilter = this._onShowFilter.bind(this)));
        this._model.on("Options", (this._onOptions = this._onOptions.bind(this)));
        this._model.on("Disabled", (this._onDisabled = this._onDisabled.bind(this)));
        this._model.on("Invalid", (this._onInvalid = this._onInvalid.bind(this)));
        this._model.on("Value", (this._onValue = this._onValue.bind(this)));
        this._model.on("Visible", (this._onVisible = this._onVisible.bind(this)));
        this._model.on("DarkTheme", (this._onDarkTheme = this._onDarkTheme.bind(this)));
        this._model.on("Focus", (this._onFocus = this._onFocus.bind(this)));
        this._model.on("Blur", (this._onBlur = this._onBlur.bind(this)));
        this._model.on("OptionsLabel", (this._onOptionsLabel = this._onOptionsLabel.bind(this)));
        this._model.on("SelectedLabel", (this._onSelectedLabel = this._onSelectedLabel.bind(this)));
        this._model.on("LineCount", (this._onLineCount = this._onLineCount.bind(this)));

        this._selectList.on(
            "Value",
            (this._onSelectListValue = this._onSelectListValue.bind(this))
        );
        this._selectList.on(
            "ValueAction",
            (this._onSelectValueAction = this._onSelectValueAction.bind(this))
        );
        this._selectList.renderer.rootElement.addEventListener(
            "click",
            (this._onSelectListClick = this._onSelectListClick.bind(this))
        );
        this._optionList.on(
            "UserValue",
            (this._onOptionListUserValue = this._onOptionListUserValue.bind(this))
        );
        this._optionList.on(
            "ValueAction",
            (this._onOptionValueAction = this._onOptionValueAction.bind(this))
        );
        this._optionList.renderer.rootElement.addEventListener(
            "click",
            (this._onOptionListClick = this._onOptionListClick.bind(this))
        );
        this._optionFilter.on(
            "UserChange",
            (this._onFilterUserChange = this._onFilterUserChange.bind(this))
        );

        this._moveOptions.addEventListener(
            "click",
            (this._onMoveOptions = this._onMoveOptions.bind(this))
        );
        this._moveSelected.addEventListener(
            "click",
            (this._onMoveSelected = this._onMoveSelected.bind(this))
        );
        this._moveAllOptions.addEventListener(
            "click",
            (this._onMoveAllOptions = this._onMoveAllOptions.bind(this))
        );
        this._moveAllSelected.addEventListener(
            "click",
            (this._onMoveAllSelected = this._onMoveAllSelected.bind(this))
        );

        this._sortUp.addEventListener("click", (this._onSortUp = this._onSortUp.bind(this)));
        this._sortDown.addEventListener("click", (this._onSortDown = this._onSortDown.bind(this)));

        this._rootElem.addEventListener(
            "click",
            (this._onClickEvent = this._onClickEvent.bind(this))
        );
        this._rootElem.addEventListener(
            "focus",
            (this._onFocusEvent = this._onFocusEvent.bind(this))
        );
        this._rootElem.addEventListener("blur", (this._onBlurEvent = this._onBlurEvent.bind(this)));
    }

    _unregisterListeners() {
        this._model.removeListener("ShowFilter", this._onShowFilter);
        this._model.removeListener("Options", this._onOptions);
        this._model.removeListener("Disabled", this._onDisabled);
        this._model.removeListener("Invalid", this._onInvalid);
        this._model.removeListener("Value", this._onValue);
        this._model.removeListener("Visible", this._onVisible);
        this._model.removeListener("DarkTheme", this._onDarkTheme);
        this._model.removeListener("Focus", this._onFocus);
        this._model.removeListener("Blur", this._onBlur);
        this._model.removeListener("OptionsLabel", this._onOptionsLabel);
        this._model.removeListener("SelectedLabel", this._onSelectedLabel);
        this._model.removeListener("LineCount", this._onLineCount);

        this._selectList.removeListener("Value", this._onSelectListValue);
        this._selectList.removeListener("ActionValue", this._onSelectValueAction);
        this._selectList.renderer.rootElement.removeEventListener("click", this._onSelectListClick);
        this._optionList.removeListener("UserValue", this._onOptionListUserValue);
        this._optionList.removeListener("ActionValue", this._onOptionValueAction);
        this._optionList.renderer.rootElement.removeEventListener("click", this._onSelectListClick);
        this._optionFilter.removeListener("UserChange", this._onFilterUserChange);

        this._moveOptions.removeEventListener("click", this._onMoveOptions);
        this._moveSelected.removeEventListener("click", this._onMoveSelected);
        this._moveAllOptions.removeEventListener("click", this._onMoveAllOptions);
        this._moveAllSelected.removeEventListener("click", this._onMoveAllSelected);

        this._sortUp.removeEventListener("click", this._onSortUp);
        this._sortDown.removeEventListener("click", this._onSortDown);

        this._rootElem.removeEventListener("click", this._onClickEvent);
        this._rootElem.removeEventListener("focus", this._onFocusEvent);
        this._rootElem.removeEventListener("blur", this._onBlurEvent);
    }

    _renderOptionListHeight(lineCount) {
        let rowHeight = rowHeightEstimate;
        let nodeList = this._optionContainer.getElementsByClassName("pick-list-row");
        if (nodeList && nodeList.length > 0) {
            let pickListRow = nodeList[0];
            let calcRowHeight = pickListRow.offsetHeight;
            if (calcRowHeight > 0) {
                rowHeight = calcRowHeight;
            }
        }
        let optionListHeight = rowHeight * lineCount;
        let height = "" + optionListHeight + "px";
        this._selectionContainer.style.height = height;
        this._optionContainer.style.height = height;
    }
    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */

    /*******************************************/
    shutdown() {
        this._unregisterListeners();

        return new Promise((resolve /*, reject*/) => {
            this._selectList.shutdown().then(() => {
                this._selectList = undefined;
            });
            this._optionList.shutdown().then(() => {
                this._optionList = undefined;
            });
            this._optionFilter.shutdown().then(() => {
                this._optionFilter = undefined;
            });
            this._selectionContainer = undefined;
            this._optionContainer = undefined;
            this._model = undefined;
            this._rootElem.remove();
            this._rootElem = undefined;
            resolve();
        });
    }

    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        return new Promise((resolve /*,reject*/) => {
            if (!this._rootElem.hasChildNodes()) {
                this._rootElem.innerHtml = "";
                this._optionsLabel.innerHTML = this._model.optionsLabel;
                this._optionContainer.appendChild(this._optionFilter.renderer.rootElement);
                this._optionContainer.appendChild(this._optionList.renderer.rootElement);
                let labeledOptionDiv = document.createElement("div");
                labeledOptionDiv.classList.add("labeled-option-container");
                labeledOptionDiv.appendChild(this._optionsLabel);
                labeledOptionDiv.appendChild(this._optionContainer);

                this._moveContainer.appendChild(this._moveAllOptions);
                this._moveContainer.appendChild(this._moveOptions);
                this._moveContainer.appendChild(this._moveSelected);
                this._moveContainer.appendChild(this._moveAllSelected);

                this._sortUp.innerHTML = "&#8593";
                this._sortDown.innerHTML = "&#8595";
                this._sortContainer.appendChild(this._sortUp);
                this._sortContainer.appendChild(this._sortDown);

                this._selectionLabel.innerHTML = this._model.selectedLabel;
                this._selectionContainer.appendChild(this._selectList.renderer.rootElement);
                let labeledSelectionDiv = document.createElement("div");
                labeledSelectionDiv.classList.add("labeled-selection-container");
                labeledSelectionDiv.appendChild(this._selectionLabel);
                labeledSelectionDiv.appendChild(this._selectionContainer);

                let selectionComponent = document.createElement("div");
                selectionComponent.classList.add("selection-component");

                selectionComponent.appendChild(labeledSelectionDiv);
                selectionComponent.appendChild(this._sortContainer);

                if (this._model.verticalLayout) {
                    this._rootElem.classList.add("v-picklist");
                    labeledOptionDiv.classList.add("v-picklist");
                    selectionComponent.classList.add("v-picklist");
                    this._moveContainer.classList.add("v-picklist");

                    this._moveAllOptions.classList.add("v-picklist");
                    this._moveOptions.classList.add("v-picklist");
                    this._moveSelected.classList.add("v-picklist");
                    this._moveAllSelected.classList.add("v-picklist");
                } else {
                    this._rootElem.classList.add("h-picklist");
                    labeledOptionDiv.classList.add("h-picklist");
                    selectionComponent.classList.add("h-picklist");
                    this._moveContainer.classList.add("h-picklist");

                    this._moveAllOptions.classList.add("h-picklist");
                    this._moveOptions.classList.add("h-picklist");
                    this._moveSelected.classList.add("h-picklist");
                    this._moveAllSelected.classList.add("h-picklist");
                }

                this._moveAllOptions.appendChild(this._createBaseIconElement("common.back"));
                this._moveOptions.appendChild(this._createBaseIconElement("common.chevron"));
                this._moveSelected.appendChild(this._createBaseIconElement("common.chevron"));
                this._moveAllSelected.appendChild(this._createBaseIconElement("common.back"));

                if (this._model.hideOptionFilter) {
                    this._optionFilter.renderer.rootElement.classList.add("hide-option-filter");
                }

                this._rootElem.appendChild(labeledOptionDiv);
                this._rootElem.appendChild(this._moveContainer);
                this._rootElem.appendChild(selectionComponent);
                this._resetOptions();

                if (this._model.lineCount) {
                    this._renderOptionListHeight(this._model.lineCount);
                }
                this._setDisabled(this._model.disabled);
            }
            resolve();
        });
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START PRIVATE RENDER METHODS */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE RENDER METHODS */
    /* START HANDLER METHODS */

    /*******************************************/

    /**
     * Fired when the show filter state has been updated in the model
     * @param newVal {boolean}
     * @private
     */
    _onShowFilter(newVal) {
        this._setShowFilter(newVal);
    }

    /**
     * Fired when the options have been updated in the model
     * @param newVal {array}
     * @private
     */
    _onOptions(/*newVal*/) {
        this._resetOptions();
    }

    /**
     * Fired when the disabled state has been updated in the model
     * @param newVal {Boolean}
     * @private
     */
    _onDisabled(newVal) {
        this._setDisabled(newVal);
    }

    /**
     * Fired when the invalid state been updated in the model
     * @param newVal {Boolean}
     * @private
     */
    _onInvalid(newVal) {
        this._setInvalid(newVal);
    }

    /**
     * Fired when the value has been updated in the model
     * @param newVal {string|object|array|boolean|number}
     * @private
     */
    _onValue(/*newVal , oldVal*/) {
        this._resetValue();
    }

    /**
     * Fired when the visible state has been updated in the model
     * @param newVal {Boolean}
     * @private
     */
    _onVisible(newVal) {
        this._setVisible(newVal);
    }

    /**
     * Fired when the darkTheme has been updated in the model
     * @param newVal {Boolean}
     * @private
     */
    _onDarkTheme(newVal) {
        this._setDarkTheme(newVal);
    }

    /**
     * Fired when focus has been called in the model
     * @private
     */
    _onFocus() {
        this._setFocus(true);
    }

    /**
     * Fired when blur has been called in the model
     * @private
     */
    _onBlur() {
        this._setFocus(false);
    }

    /**
     * Fired when the user has changed the value of the selected list
     * @param newVal {string|boolean|array|object|number}
     * @param oldVal {string|boolean|array|object|number}
     * @param event {event}
     * @private
     */
    _onSelectListValue(newVal /*, oldVal, event*/) {
        if (_.isArray(newVal) && newVal.length === 1) {
            this._sortContainer.removeAttribute("disabled");
        } else {
            this._sortContainer.setAttribute("disabled", "disabled");
        }
        if (!_.isEqual(newVal, this._model.selectionHighlight)) {
            this._model.selectionHighlight = newVal;
        }
    }

    /**
     * Kill event bubbling at the selected list level so the click event doesn't bubble up
     * to the root element
     * @param event {event}
     * @private
     */
    _onSelectListClick(/*event*/) {
        event.stopImmediatePropagation();
    }

    /**
     * Fired when the user has changed the value of the option list
     * @param newVal {string|boolean|array|object|number}
     * @param oldVal {string|boolean|array|object|number}
     * @param event {event}
     * @private
     */
    _onOptionListUserValue(/*newVal, oldVal, event*/) {}

    /**
     * Kill event bubbling at the option list level so the click event doesn't bubble up
     * to the root element
     * @param event {event}
     * @private
     */
    _onOptionListClick(/*event*/) {
        event.stopImmediatePropagation();
    }

    _clearFilter() {
        this._optionFilter.setValue("");
        this._resetOptions();
    }

    /**
     * Fired when the user has changed the value of the filter
     * @param newVal {string}
     * @private
     */
    _onFilterUserChange(/*newVal*/) {
        this._resetOptions();
        this._optionList.value = [];
    }

    /**
     * Fired when the control is clicked
     * @param event {Event}
     * @private
     */
    _onClickEvent(/*event*/) {
        event.stopImmediatePropagation();
    }

    /**
     * Pass the focus event up to the model
     * @param event {Event}
     * @private
     */
    _onFocusEvent(event) {
        this._model._triggerUserFocus(event);
    }

    /**
     * Pass the blur event up to the model
     * @param event {Event}
     * @private
     */
    _onBlurEvent(event) {
        this._model._triggerUserBlur(event);
    }

    /**
     * Move options button was clicked.
     * @param event
     * @private
     */
    _onMoveOptions(/*event*/) {
        let selectedOptions = this._optionList.value;
        this._moveSpecifiedOptions(selectedOptions);
    }

    /**
     * Move all options was clicked.
     * @param event
     * @private
     */
    _onMoveAllOptions(/*event*/) {
        if (!this._model.disabled) {
            let optionValues = [];
            this._optionList.options.forEach((option) => {
                optionValues.push(option.value);
            });
            this._moveSpecifiedOptions(optionValues);
        }
    }

    /**
     * Move selected was clicked
     * @param event
     * @private
     */
    _onMoveSelected(/*event*/) {
        let selectedValues = this._selectList.value;
        let currentValues = _.cloneDeep(this._model.value);
        if (!_.isEmpty(selectedValues)) {
            selectedValues.forEach((selectedValue) => {
                currentValues.forEach((currentValue, index) => {
                    if (_.isEqual(currentValue, selectedValue)) {
                        currentValues.splice(index, 1);
                    }
                });
            });
            this._selectList.value = [];
            this._model.value = currentValues;
        }
    }

    /**
     * Move all selected was clicked.
     * @param event
     * @private
     */
    _onMoveAllSelected(/*event*/) {
        if (!this._model.disabled) {
            this._selectList.value = [];
            this._model.value = [];
        }
    }

    _onSelectValueAction(event) {
        if (this._model.moveOnDblClick) {
            this._onMoveSelected(event);
        }
    }

    _onOptionValueAction(event) {
        if (this._model.moveOnDblClick) {
            this._onMoveOptions(event);
        }
    }

    _onSortUp(/*event*/) {
        let selected = this._selectList.value;
        if (_.isArray(selected) && selected.length === 1) {
            let currentValue = _.cloneDeep(this._model.value);
            let searchValue = selected[0];
            currentValue.forEach((value, index) => {
                if (_.isEqual(value, searchValue) && index > 0) {
                    currentValue.splice(index, 1);
                    currentValue.splice(index - 1, 0, value);
                }
            });
            this._model.value = currentValue;
            this._selectList.value = selected;
        }
    }

    _onSortDown(/*event*/) {
        let selected = this._selectList.value;
        if (_.isArray(selected) && selected.length === 1) {
            let currentValue = _.cloneDeep(this._model.value);
            let searchValue = selected[0];
            let applyMove = true;
            currentValue.forEach((value, index) => {
                if (applyMove && _.isEqual(value, searchValue) && index < currentValue.length - 1) {
                    currentValue.splice(index, 1);
                    currentValue.splice(index + 1, 0, value);
                    applyMove = false;
                }
            });
            this._model.value = currentValue;
            this._selectList.value = selected;
        }
    }

    /**
     * Handle a change on the option label
     * @param event
     * @private
     */
    _onOptionsLabel(/*event*/) {
        this._optionsLabel.innerHTML = this._model.optionsLabel;
    }

    /**
     * Handle a change on the selected label
     * @param event
     * @private
     */
    _onSelectedLabel(/*event*/) {
        this._selectionLabel.innerHTML = this._model.selectedLabel;
    }

    _onLineCount(event) {
        this._renderOptionListHeight(event);
    }

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/

    _moveSpecifiedOptions(selectedOptions) {
        let currentValue = _.cloneDeep(this._model.value);
        if (!_.isEmpty(selectedOptions)) {
            let existingOptions = this._model.options;
            let orderedSelectedOptions = [];
            // This is bit of a hack to push the selected over in the same order
            // they appear in the options list
            existingOptions.forEach((option) => {
                selectedOptions.forEach((selected) => {
                    if (_.isEqual(option.value, selected)) {
                        orderedSelectedOptions.push(selected);
                    }
                });
            });

            orderedSelectedOptions.forEach((value) => {
                currentValue.push(value);
            });
            this._optionList.value = [];
            this._selectList.value = [];
            this._model.value = currentValue;
        }
    }

    _removeSelectedValues(unfilteredOptions) {
        this._model.value.forEach((value) => {
            unfilteredOptions.forEach((option, index) => {
                if (_.isEqual(option.value, value)) {
                    unfilteredOptions.splice(index, 1);
                }
            });
        });
    }

    /**
     * Filters the displaying options based on the filter
     * @param unfilteredOptions [object]
     * @private
     */
    _applyFilter(unfilteredOptions) {
        let filterVal = this._optionFilter.getValue();
        let filteredOptions = [];
        if (!filterVal || filterVal === "") {
            filteredOptions = _.cloneDeep(unfilteredOptions);
        } else {
            unfilteredOptions.forEach((option) => {
                if (option.label.toLowerCase().includes(filterVal.toLowerCase())) {
                    filteredOptions.push(option);
                }
            });
        }
        return filteredOptions;
    }

    /**
     * Set the inner options with the passed in array of options from the model
     * @private
     */
    _resetOptions() {
        let displayOptions = this._applyFilter(this._model.options);
        this._removeSelectedValues(displayOptions);
        this._optionList.options = displayOptions;
    }

    /**
     * Display the search filter, if enabled
     * @param newVal {boolean}
     * @private
     */
    _setShowFilter(newVal) {
        if (newVal === true) {
            this._optionContainer.classList.add("show-filter");
        } else {
            this._optionContainer.classList.remove("show-filter");
        }
    }

    /**
     * Toggle the disabled state
     * @param newVal {Boolean}
     * @private
     */
    _setDisabled(newVal) {
        if (newVal === true) {
            this._rootElem.setAttribute("disabled", true);
            this._rootElem.tabIndex = -1;
            this._selectList.disabled = true;
            this._optionList.disabled = true;
            this._optionFilter.disabled = true;
            this._moveContainer.setAttribute("disabled", true);
        } else {
            this._rootElem.removeAttribute("disabled");
            this._rootElem.tabIndex = 0;
            this._selectList.disabled = false;
            this._optionList.disabled = false;
            this._optionFilter.disabled = false;
            this._moveContainer.removeAttribute("disabled", true);
        }
    }

    /**
     * Toggle the invalid state
     * @param newVal {Boolean}
     * @private
     */
    _setInvalid(newVal) {
        if (newVal === true) {
            this._rootElem.classList.add("invalid");
        } else {
            this._rootElem.classList.remove("invalid");
        }
    }

    /**
     * Set the option active that matches the new value
     * @private
     */
    _resetValue() {
        let currentSelected = _.cloneDeep(this._model.value);
        if (
            _.isUndefined(currentSelected) ||
            (currentSelected instanceof Array && currentSelected.length === 0)
        ) {
            this._selectList.options = [];
        } else if (currentSelected instanceof Array) {
            this._buildSelectedOptions(currentSelected);
        } else {
            this._model.options.forEach((option) => {
                if (_.isEqual(option.value, currentSelected)) {
                    this._selectList = [option];
                }
            });
        }
        this._resetOptions();
    }

    /**
     * Toggle the visible state
     * @param newVal {Boolean}
     * @private
     */
    _setVisible(newVal) {
        if (newVal === true) {
            this._rootElem.classList.remove("hidden");
        } else {
            this._rootElem.classList.add("hidden");
        }
    }

    /**
     * Toggle or set the dark theme
     * @param newVal {Boolean}
     * @private
     */
    _setDarkTheme(newVal) {
        if (newVal === true) {
            this._rootElem.classList.add("dark");
            this._selectList.darkTheme = true;
            this._optionFilter.darkTheme = true;
        } else {
            this._rootElem.classList.remove("dark");
            this._selectList.darkTheme = false;
            this._optionFilter.darkTheme = false;
        }
    }

    /**
     * Set or remove focus
     * @param newVal {Boolean}
     * @private
     */
    _setFocus(newVal) {
        if (newVal === true) {
            this._rootElem.focus();
        } else {
            this._rootElem.blur();
        }
    }

    _buildSelectedOptions(selectedValues) {
        let selectedOptions = [];
        selectedValues.forEach((value) => {
            this._model.options.forEach((option) => {
                if (_.isEqual(option.value, value)) {
                    selectedOptions.push(option);
                }
            });
        });
        this._selectList.options = selectedOptions;
    }

    _createBaseIconElement(iconName) {
        let baseIconElement = document.createElement("base-icon-gl");
        baseIconElement.setAttribute("data-icon", iconName);
        return baseIconElement;
    }

    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}

module.exports = PickListRenderer;
